
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { GlobeAltIcon, CogIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { useCookieConsent } from '@/context/CookieConsentContext';

const CookieConsentBanner: React.FC = () => {
  const { showBanner, acceptAll, rejectAll, openSettings } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background/95 backdrop-blur-sm border-t shadow-lg">
      <Card className="max-w-6xl mx-auto p-6">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4">
          <div className="flex items-start gap-3 flex-1">
            <GlobeAltIcon className="h-6 w-6 text-primary mt-1 flex-shrink-0" />
            <div className="space-y-2">
              <h3 className="font-semibold text-lg">Cookie Consent</h3>
              <p className="text-sm text-muted-foreground">
                We use cookies to enhance your experience on AccZen.net. Essential cookies are required for site functionality, 
                while analytics cookies help us improve our services. You can customize your preferences at any time.
              </p>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <span>Read our</span>
                <a 
                  href="/privacy" 
                  className="text-primary hover:underline font-medium"
                >
                  Privacy Policy
                </a>
                <span>for more details.</span>
              </div>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto">
            <Button
              variant="outline"
              size="sm"
              onClick={rejectAll}
              className="flex items-center gap-2"
            >
              <XMarkIcon className="h-4 w-4" />
              Reject All
            </Button>
            
            <Button
              variant="outline"
              size="sm"
              onClick={openSettings}
              className="flex items-center gap-2"
            >
              <CogIcon className="h-4 w-4" />
              Customize
            </Button>
            
            <Button
              size="sm"
              onClick={acceptAll}
              className="bg-primary hover:bg-primary/90"
            >
              Accept All
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CookieConsentBanner;
